// Class-based styles for the gallery grid + lightbox, injected via a <style>
// tag in StoreGallery so we get real :hover/animation states (the rest of the
// shop uses inline style objects in styles.js).
const galleryCss = `
.sg-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(200px,1fr)); gap:1rem; }
@media (max-width:560px){ .sg-grid { grid-template-columns:repeat(2,1fr); gap:0.6rem; } }
/* Horizontal photo carousel for the flow gallery (Figma layout). */
.sg-rail { display:flex; gap:1rem; overflow-x:auto; padding:0.25rem 0.25rem 1rem;
  scroll-snap-type:x mandatory; -webkit-overflow-scrolling:touch; }
.sg-rail > * { flex:0 0 auto; width:220px; scroll-snap-align:start; }
.sg-rail::-webkit-scrollbar { height:8px; }
.sg-rail::-webkit-scrollbar-thumb { background:rgba(0,0,0,.18); border-radius:8px; }
@media (max-width:560px){ .sg-rail > * { width:160px; } }
/* Template preview composes a photo into a LookTemplate; cqh lets text scale
   with the rendered canvas size (see TemplatePreview.jsx). */
.sg-tpl { container-type: size; }
/* Popular Photo Products grid: 2-col mobile, 4-col desktop (Figma gallery). */
.sg-popular-grid { display:grid; grid-template-columns:repeat(2,1fr); gap:1rem; }
@media (min-width:900px){ .sg-popular-grid { grid-template-columns:repeat(4,1fr); } }
.sg-tile { position:relative; border-radius:12px; overflow:hidden; background:#f3f4f6;
  box-shadow:0 1px 3px rgba(0,0,0,.08); transition:box-shadow .15s, transform .15s; }
.sg-tile:hover { box-shadow:0 8px 24px rgba(0,0,0,.18); transform:translateY(-2px); }
.sg-tile--processing { aspect-ratio:4/5; display:flex; align-items:center; justify-content:center; }
.sg-tile-btn { display:block; width:100%; border:none; padding:0; background:none; cursor:pointer; }
.sg-img { width:100%; aspect-ratio:4/5; object-fit:cover; display:block;
  background-size:cover; background-position:center; background-color:#e5e7eb; }
.sg-hint { position:absolute; left:0; right:0; bottom:0; padding:.55rem; color:#fff;
  font-size:.8rem; font-weight:600; text-align:center;
  background:linear-gradient(transparent,rgba(0,0,0,.6));
  opacity:0; transition:opacity .15s; pointer-events:none; }
.sg-tile:hover .sg-hint { opacity:1; }
.sg-fav { position:absolute; top:.5rem; right:.5rem; width:34px; height:34px;
  border-radius:50%; border:none; background:rgba(255,255,255,.9); color:#9ca3af;
  font-size:1.15rem; line-height:1; cursor:pointer; box-shadow:0 1px 3px rgba(0,0,0,.2); }
.sg-fav--on { color:#ef4444; }
.sg-shimmer { position:absolute; inset:0; background:linear-gradient(90deg,#f3f4f6 25%,#e5e7eb 37%,#f3f4f6 63%);
  background-size:400% 100%; animation:seniorShimmer 1.4s ease infinite; }
.sg-processing { position:relative; color:#6b7280; font-size:.85rem; }

/* Full-screen pose preview (Figma "Picture Day Preview"). */
.sg-lb-backdrop { position:fixed; inset:0; background:rgba(0,0,0,.95); z-index:1060;
  display:flex; flex-direction:column; align-items:center; justify-content:center; padding:5rem 1rem; }
.sg-lb-head { position:absolute; top:0; left:0; right:0; padding:1.25rem; text-align:center;
  background:linear-gradient(to bottom, rgba(0,0,0,.8), transparent); pointer-events:none; }
.sg-lb-head h2 { color:#fff; font-size:1.4rem; font-weight:700; margin:0; }
.sg-lb-head p { color:rgba(255,255,255,.72); font-size:.9rem; margin:.25rem 0 0; }
.sg-lb { position:relative; display:flex; flex-direction:column; align-items:center; gap:1rem;
  max-width:min(92vw,720px); }
.sg-lb-stage { position:relative; display:flex; align-items:center; justify-content:center; width:100%; }
.sg-lb-imgwrap { position:relative; max-height:54vh; min-width:200px; min-height:200px;
  display:flex; align-items:center; justify-content:center; }
.sg-lb-img { display:block; max-width:100%; max-height:54vh; object-fit:contain; border-radius:10px;
  background-size:cover; background-position:center; opacity:0; transition:opacity .25s ease; }
.sg-lb-img.is-loaded { opacity:1; }
.sg-lb-spinner { position:absolute; top:50%; left:50%; width:42px; height:42px; margin:-21px 0 0 -21px;
  border-radius:50%; border:3px solid rgba(255,255,255,.25); border-top-color:#fff;
  animation:seniorSpin .9s linear infinite; }
.sg-lb-counter { position:absolute; top:12px; left:12px; background:rgba(0,0,0,.5); color:#fff;
  padding:.25rem .7rem; border-radius:999px; font-size:.8rem; backdrop-filter:blur(4px); }
.sg-lb-favbadge { position:absolute; top:12px; right:12px; background:#ef4444; color:#fff;
  padding:.25rem .7rem; border-radius:999px; font-size:.8rem; display:inline-flex; gap:4px; align-items:center; }
.sg-lb-heart { position:absolute; bottom:12px; right:12px; width:44px; height:44px; border-radius:50%;
  border:none; cursor:pointer; font-size:1.2rem; line-height:1; background:rgba(0,0,0,.5); color:#fff;
  backdrop-filter:blur(4px); transition:background .15s, transform .15s; }
.sg-lb-heart:hover { transform:scale(1.06); }
.sg-lb-heart.is-on { background:#ef4444; color:#fff; }
.sg-lb-nav { position:absolute; top:50%; transform:translateY(-50%); width:48px; height:48px; z-index:2;
  border-radius:50%; border:none; background:rgba(0,0,0,.5); color:#fff; font-size:1.7rem; cursor:pointer; }
.sg-lb-prev { left:-8px; } .sg-lb-next { right:-8px; }
.sg-lb-close { position:absolute; top:18px; right:18px; background:rgba(255,255,255,.08); border:none;
  color:#fff; font-size:1.6rem; line-height:1; cursor:pointer; width:40px; height:40px; border-radius:8px; }
.sg-lb-thumbs { display:flex; gap:.5rem; overflow-x:auto; max-width:100%; padding:.25rem; }
.sg-lb-thumb { position:relative; flex:0 0 auto; width:64px; height:80px; border-radius:8px; overflow:hidden;
  border:2px solid rgba(255,255,255,.3); background:none; padding:0; cursor:pointer; }
.sg-lb-thumb.is-active { border-color:#008fcf; box-shadow:0 0 0 2px rgba(0,143,207,.35); }
.sg-lb-thumb img { width:100%; height:100%; object-fit:cover; display:block;
  background-size:cover; background-position:center; }
.sg-lb-thumb-fav { position:absolute; top:3px; right:3px; background:#ef4444; color:#fff; border-radius:50%;
  width:18px; height:18px; font-size:.7rem; display:flex; align-items:center; justify-content:center; }
.sg-lb-actions { position:absolute; bottom:0; left:0; right:0; padding:1.25rem; z-index:2;
  display:flex; flex-direction:column; gap:.6rem; align-items:center;
  background:linear-gradient(to top, rgba(0,0,0,.8), transparent); }
.sg-lb-selectall { width:min(420px,90vw); background:rgba(255,255,255,.1); color:#fff;
  border:1px solid rgba(255,255,255,.3); border-radius:10px; padding:.75rem; cursor:pointer; font-weight:600; }
.sg-lb-shop { width:min(420px,90vw); background:#008fcf; color:#fff; border:none; border-radius:10px;
  padding:.8rem; font-weight:700; cursor:pointer; }
.sg-lb-shop:hover { background:#007ab8; }
@media (max-width:640px){ .sg-lb-prev{left:0;} .sg-lb-next{right:0;} }

@keyframes seniorShimmer { 0% { background-position:100% 0; } 100% { background-position:0 0; } }
@keyframes seniorSpin { to { transform:rotate(360deg); } }

.sg-toasts { position:fixed; top:1rem; left:50%; transform:translateX(-50%); z-index:1090;
  display:flex; flex-direction:column; gap:.5rem; align-items:center; max-width:92vw; pointer-events:none; }
.sg-toast { display:flex; align-items:center; gap:.55rem; padding:.6rem .8rem .6rem 1rem;
  border-radius:10px; font-size:.9rem; font-weight:600; color:#fff; pointer-events:auto;
  box-shadow:0 8px 24px rgba(0,0,0,.24); animation:sgToastIn .22s ease; }
.sg-toast--success { background:#059669; }
.sg-toast--error { background:#dc2626; }
.sg-toast--info { background:#008fcf; }
.sg-toast-icon { font-weight:800; }
.sg-toast-x { background:none; border:none; color:rgba(255,255,255,.85); cursor:pointer;
  font-size:1.1rem; line-height:1; padding:0 .1rem; }
@keyframes sgToastIn { from { opacity:0; transform:translateY(-8px); } to { opacity:1; transform:none; } }

/* Slide-in panels + fading backdrop for the shop overlays. */
.sg-panel { animation: sgPanelIn .26s cubic-bezier(.22,.61,.36,1); }
@keyframes sgPanelIn { from { transform:translateX(100%); } to { transform:none; } }
.sg-backdrop { animation: sgFadeIn .2s ease; }
@keyframes sgFadeIn { from { opacity:0; } to { opacity:1; } }

/* Fade images in once they load instead of popping. */
.sg-img, .sg-hero { opacity:0; transition:opacity .35s ease; }
.sg-img.is-loaded, .sg-hero.is-loaded { opacity:1; }

@media (prefers-reduced-motion: reduce) {
  .sg-panel, .sg-backdrop, .sg-toast { animation:none; }
  .sg-img, .sg-hero { transition:none; opacity:1; }
}
`;

export default galleryCss;
